import { toast } from 'react-toastify';

const key = 'staffSessionToken';

export function getStaffSessionToken(): string | null {
  const token = sessionStorage.getItem(key);
  if (!token) return null;
  try {
    const encoded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(atob(encoded));
    if (claims.kind === 'staff' && typeof claims.exp === 'number' && claims.exp * 1000 > Date.now())
      return token;
  } catch { /* Invalid cached sessions require a fresh Google sign-in. */ }
  sessionStorage.removeItem(key);
  return null;
}

export function saveStaffSessionToken(token: string): void {
  sessionStorage.removeItem('adminPassword');
  sessionStorage.setItem(key, token);
}

export function staffSessionHeaders(): Record<string, string> {
  const token = getStaffSessionToken();
  return token ? { 'X-Staff-Session': token } : {};
}

export function clearStaffSession(): void {
  sessionStorage.removeItem(key);
  sessionStorage.removeItem('adminPassword');
}

export async function revokeCurrentStaffSession(): Promise<void> {
  const token = getStaffSessionToken();
  if (!token) return;
  const base = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_DEV_BASE_URL || 'http://192.168.1.85:3001/'
    : process.env.REACT_APP_PROD_BASE_URL || 'https://new-test-w4ono.ondigitalocean.app';
  try {
    const response = await fetch(base.replace(/\/$/, '') + '/auth/staff-logout', {
      method: 'POST', headers: { 'X-Staff-Session': token, 'Content-Type': 'application/json' },
      body: '{}', cache: 'no-store'
    });
    if (!response.ok && response.status !== 401) throw new Error('logout unavailable');
  } catch {
    toast.error('Signed out locally, but the server could not revoke this session. Revoke it from Staff access when the connection returns.');
  } finally {
    clearStaffSession();
  }
}
